var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 20.0052L20.2507 16.0052L13.3307 12.0052V20.0052ZM28.7441 9.56521C28.9174 10.1919 29.0374 11.0319 29.1174 12.0985C29.2107 13.1652 29.2507 14.0852 29.2507 14.8852L29.3307 16.0052C29.3307 18.9252 29.1174 21.0719 28.7441 22.4452C28.4107 23.6452 27.6374 24.4185 26.4374 24.7519C25.8107 24.9252 24.6641 25.0452 22.9041 25.1252C21.1707 25.2185 19.5841 25.2585 18.1174 25.2585L15.9974 25.3385C10.4107 25.3385 6.93073 25.1252 5.5574 24.7519C4.3574 24.4185 3.58406 23.6452 3.25073 22.4452C3.0774 21.8185 2.9574 20.9785 2.8774 19.9119C2.78406 18.8452 2.74406 17.9252 2.74406 17.1252L2.66406 16.0052C2.66406 13.0852 2.8774 10.9385 3.25073 9.56521C3.58406 8.36521 4.3574 7.59188 5.5574 7.25854C6.18406 7.08521 7.33073 6.96521 9.09073 6.88521C10.8241 6.79187 12.4107 6.75187 13.8774 6.75187L15.9974 6.67188C21.5841 6.67188 25.0641 6.88521 26.4374 7.25854C27.6374 7.59188 28.4107 8.36521 28.7441 9.56521Z",
    fill: "#321E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiYoutube);
export default __webpack_public_path__ + "static/media/mdi_youtube.f54424f7156bdbbab4cb6459fcbfb91b.svg";
export { ForwardRef as ReactComponent };